module.exports = __webpack_public_path__ + "img/bdelanacion.efb391a1.svg";